import { Progress } from "@/components/ui/progress";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Stem } from '@/types/stem';

const FREE_MINUTES_LIMIT = 60;

export const ProcessingLimitDisplay = () => {
  const { data: totalMinutes = 0 } = useQuery({
    queryKey: ['processingTime'],
    queryFn: async () => {
      console.log('Fetching processing time...');
      const sessionId = localStorage.getItem('stem_session_id');
      
      const { data: sessions } = await supabase
        .from('stem_sessions')
        .select('stems')
        .eq('session_id', sessionId);

      if (!sessions) {
        console.log('No sessions found');
        return 0;
      }

      console.log('Found sessions:', sessions);

      // Calculate total minutes by summing up the duration of all stems
      const total = sessions.reduce((acc, session) => {
        if (!session.stems) return acc;
        
        const stems = session.stems as Stem[];
        if (stems.length === 0) return acc;
        
        // Get the duration of the first stem (they all have the same duration)
        const firstStem = stems[0];
        if (!firstStem?.duration) return acc;

        // Convert duration from seconds to minutes
        const durationInMinutes = Number(firstStem.duration) / 60;
        if (isNaN(durationInMinutes)) {
          console.log('Invalid duration:', firstStem.duration);
          return acc;
        }

        // Multiply by number of stems since each stem takes the same processing time
        const sessionProcessingTime = durationInMinutes * stems.length;
        
        console.log('Session processing time:', {
          stemCount: stems.length,
          durationInMinutes,
          sessionProcessingTime
        });
        
        return acc + sessionProcessingTime;
      }, 0);

      console.log('Total processing minutes:', total);
      return Math.round(total); // Round to nearest minute for display
    },
  });

  // Keeping the calculations in case we need them later, but not displaying anything
  const percentageUsed = (totalMinutes / FREE_MINUTES_LIMIT) * 100;
  const minutesLeft = FREE_MINUTES_LIMIT - totalMinutes;

  // Return an empty div for now
  return <div className="p-4"></div>;
};
